module.exports = __webpack_public_path__ + "static/media/interview.47d72082.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/interview.jpg
// module id = 614
// module chunks = 0